import { NewsletterSubscribe } from "@/components/resources/components/SiteFooter/NewsletterSubscribe"

interface NewsletterTeaserProps extends React.HTMLAttributes<HTMLDivElement> {
  as: React.ElementType
}

export const NewsletterTeaser = ({
  as: Component = "div",
  className,
  ...props
}: NewsletterTeaserProps) => {
  return (
    <Component
      className={`rounded-2xl bg-bg-surface border border-solid border-border-default overflow-hidden relative flex flex-col justify-center w-full items-center text-center self-stretch py-6 md:py-8 lg:py-12 px-6 md:px-8 lg:px-12 ${className || ""}`}
      {...props}
    >
      <div className="w-full flex flex-col gap-2 items-center justify-inherit">
        <p className="text-xl md:text-2xl font-medium">Stay in the loop</p>
        <p className="text-fg-secondary mb-4">
          Join our mailing list to get the latest insights!
        </p>
        <form className="max-w-[226px] flex flex-col gap-4 w-full">
          <NewsletterSubscribe className="w-full" type="submit" />
        </form>
      </div>
    </Component>
  )
}
